import React, { createContext, useContext, useState } from "react";
import { IProviderProps, IUnitContext } from "../@types/ContextProviderRelated";
import { EUnitType } from "../@types/Enums";

const unitProviderDefaultValues: IUnitContext = {
    unitType: EUnitType.METRIC,
    setUnitType: () => {}
};

export const UnitContext = createContext(unitProviderDefaultValues);

export const useUnitContext = () => useContext(UnitContext);

export const UnitProvider = ({ children }: IProviderProps): JSX.Element => {
    const [unitType, setUnitType] = useState<EUnitType>(unitProviderDefaultValues.unitType);
    return (
        <UnitContext.Provider value={{
            unitType,
            setUnitType
        }}>
            {children}
        </UnitContext.Provider>
    );
};

export default UnitProvider;